module.exports = __webpack_public_path__ + "img/didaima01.630ff484.jpg";